import { cn } from '@/lib/utils';
import { Crown, Star, Sparkles } from 'lucide-react';

interface VIPBadgeProps {
  variant?: 'default' | 'gold' | 'premium' | 'exclusive';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children?: React.ReactNode;
  icon?: 'crown' | 'star' | 'sparkles' | 'none';
  animated?: boolean;
}

const VIPBadge = ({ 
  variant = 'default', 
  size = 'md', 
  className,
  children = 'VIP',
  icon = 'crown',
  animated = false
}: VIPBadgeProps) => {
  const variantStyles = {
    default: 'bg-gradient-to-r from-primary via-accent to-secondary text-white',
    gold: 'bg-gradient-to-r from-primary to-secondary text-white border border-primary/50',
    premium: 'bg-vip-dark text-primary border-2 border-primary',
    exclusive: 'bg-gradient-to-r from-secondary via-primary to-accent text-white shadow-gold',
  };

  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs gap-1',
    md: 'px-3 py-1 text-sm gap-1.5',
    lg: 'px-4 py-2 text-base gap-2',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const IconComponent = {
    crown: Crown,
    star: Star,
    sparkles: Sparkles,
    none: null,
  }[icon];

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center font-bold rounded-full',
        variantStyles[variant],
        sizeStyles[size],
        animated && 'animate-pulse-glow',
        className
      )}
    >
      {IconComponent && <IconComponent className={iconSizes[size]} />}
      {children}
    </span>
  );
};

export default VIPBadge;
